import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { LoaderService, Message } from "@stdoutsrl/design-kit";
import { RestService } from "@stdoutsrl/design-kit";
import { api } from "../../environments/environment";
import { BookingService } from "../service/booking.service";

@Component({
  selector: "app-ProductAssociation",
  template: `
    <std-modal
      *transloco="let t"
      cardClass="!max-w-[90vw]"
      headerClass="bg-primary"
      [show]="true"
      [closeOnOutside]="false"
      (close)="autoDestory()"
    >
      <div class="text-tertiary text-large" header>
        {{ t(fatherElement ? "modal.edit" : "modal.newElement") }}
      </div>
      <div content class="max-h-[70vh] overflow-y-scroll custom-scrollbar">
        <div class="mt-4 grid gap-4">
          <std-select
            customLabel="label-input"
            customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
            type="number"
            [data]="dataForSpecial.salons"
            (onChangeValue)="manageSpecial($event, 'salonId')"
            bindLabel="name"
            bindValue="id"
            [label]="t('salon') + '*'"
            labelPosition="top"
            [placeholder]="t('salon') + '*'"
          ></std-select>

          <std-select
            customLabel="label-input"
            customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
            type="number"
            (onChangeValue)="manageSpecial($event, 'operatorId')"
            [data]="dataForSpecial.operators"
            bindLabel="firstName"
            bindValue="id"
            [label]="t('operator') + '*'"
            labelPosition="top"
            [placeholder]="t('operator') + '*'"
          ></std-select>

          <std-select
            customLabel="label-input"
            customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
            type="number"
            bindValue="id"
            (onChangeValue)="manageSpecial($event, 'status')"
            [data]="[
              { id: 0, label: 'Disattiva' },
              { id: 1, label: 'Attiva' }
            ]"
            [label]="t('status') + '*'"
            labelPosition="top"
            [placeholder]="t('status') + '*'"
          ></std-select>
        </div>
        <div class="mt-6 flex gap-4">
          <std-button
            buttonClass="bg-primary focus:bg-primary hover:bg-primary"
            (click)="autoDestory()"
            class="w-[200px]"
            >{{ t("modal.cancel") }}</std-button
          >
          <std-button
            buttonClass="bg-primary focus:bg-primary hover:bg-primary"
            (click)="sendAggregation()"
            class="w-[200px]"
            >{{ t("modal.confirm") }}</std-button
          >
        </div>
      </div>
    </std-modal>
  `,
  styles: [],
  standalone: false,
})
export class ProductAssociationComponent implements OnInit {
  @Input() fatherElement: any = {};
  dataForAggregate: any = {};
  dataForSpecial: any = {};
  constructor(
    private host: ElementRef<HTMLElement>,
    private message: Message,
    private rest: RestService,
    private loader: LoaderService,
    private booking: BookingService
  ) {}

  ngOnInit(): void {
    // this.getAllSpecial();
  }

  manageSpecial(event: any, what: string, special?: boolean) {
    this.dataForAggregate[what] = event.id;
  }

  sendAggregation() {
    if (
      this.dataForAggregate.companyId &&
      this.dataForAggregate.salonId &&
      this.dataForAggregate.operatorId &&
      this.dataForAggregate.itemId &&
      (this.dataForAggregate.status == 0 || this.dataForAggregate.status == 1)
    ) {
      this.rest
        .post(
          `/company/${this.dataForAggregate.companyId}/${this.dataForAggregate.salonId}/${this.dataForAggregate.operatorId}/assign/${this.dataForAggregate.itemId}/${this.dataForAggregate.status}`,
          {}
        )
        .subscribe({
          next: (value) => {
            this.message.showMessage("Creata associazione", "success");
            this.autoDestory();
          },
          error: (value) => {
            this.message.showMessage(
              "Errore nella creazione dell'associazione",
              "error"
            );
            this.autoDestory();
          },
        });
    } else {
      this.message.showMessage("Devi compilare tutti i campi", "error");
    }
  }

  getAllSpecial() {
    this.booking.getMyCompany().subscribe({
      next: (value: any) => {
        const id = value[0].id;
        this.dataForAggregate.companyId = id;
        this.booking.getMySalons().subscribe({
          next: (value: any) => {
            this.loader.off(true);
            this.dataForSpecial.salons = value;
          },
          error: (value) => {
            this.loader.off(true);
          },
        });
        this.booking.getMyOperators(id).subscribe({
          next: (value: any) => {
            this.loader.off(true);
            this.dataForSpecial.operators = value.map((res: any) => {
              res.fullName = res.firstName + " " + res.lastName;
              return res;
            });
          },
          error: (value) => {
            this.loader.off(true);
          },
        });
      },
      error: (value) => {
        this.loader.off(true);
      },
    });
  }

  autoDestory() {
    this.host.nativeElement.remove();
  }
}
